
import { faCheck, faClock } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'PurchasingBlocker',

  data() {
    return {
      faClock,
      faCheck
    }
  },

  computed: {
    compIsVisible() {
      return (
        (this.$store.state.booking.isPurchasing ||
          this.$store.state.booking.isVerifying ||
          this.$store.state.booking.verifyOrderError) &&
        this.$route.path.includes('/book/checkout')
      )
    }
  },

  methods: {
    onTryAgain() {
      this.$store.commit('booking/setRetriedPaymentAt', this.$dateNew.now().toSQLDate())

      this.resetAndCloseModal()
    },

    resetAndCloseModal() {
      this.$log.debug('Payment verification failed, closing modal')

      this.$store.commit('booking/setVerifyOrderError', null)
      this.$store.commit('booking/setIsPurchasing', false)
      this.$store.commit('booking/setIsVerifying', false)
    },

    onGetHelp() {
      this.$log.debug('Payment verification failed, opening help modal')

      this.$modal.open('global/help')
      this.resetAndCloseModal()
    }
  }
}
